export const _sharedActionsConstantsToc = {
  SET_ITEM: "toc/SET_ITEM",
  FETCH: "toc/FETCH",
};

export const _sharedActionsToc = {
  setItem: (bookIdOrigin, toc) => ({
    type: _sharedActionsConstantsToc.SET_ITEM,
    data: { bookIdOrigin, toc },
  }),
  fetch: (nBookId) => ({
    type: _sharedActionsConstantsToc.FETCH,
    data: nBookId,
  }),
};
